/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { RefObject } from 'react';
import { Button } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';


export interface IInputFileButton {
  id: string;
  accept: string;
  buttonId: string;
  buttonLabel: string;
  onChange: (e: any) => void;
  inputRef: RefObject<HTMLInputElement>;
  name?: string;
  disabled?: boolean
}

/**
 * InputFileButton
 * @param {IInputFileButton} props
 * @return {React.JSX.Element}
 */
export default function InputFileButton(props: IInputFileButton): React.JSX.Element {
  /**
   * Force open file picker
   * @return {void}
   */
  function pickFile(): void {
    props.inputRef.current?.click();
  }

  return (
    <label htmlFor={props.id}>
      <input
        hidden
        multiple
        type="file"
        id={props.id}
        name={props.name}
        accept={props.accept}
        ref={props.inputRef}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <Button
        disabled={props.disabled}
        id={props.buttonId}
        variant='goFoward'
        onClick={pickFile}
        endIcon={<UploadFileIcon />}
      >
        {props.buttonLabel}
      </Button>
    </label>
  );
}
